module.exports = __webpack_public_path__ + "static/media/Illus-SideVeggie@2x.8c0490c7.png";